module.exports = __webpack_public_path__ + "media/images/products/IMG_20210704_163137_HDR-removebg-preview-29ac2a93b13856e1d5d1930ff75e22ae.png";